/**
 * ShareCartLink class.
 */
export class ShareCartLink {
	/**
	 * Initialize share cart links.
	 *
	 * @return {void}
	 */
	static init() {
		const shareCartLinks = document.querySelectorAll( '.js-qala-ssc-share-cart-link' );
		const shareCartMessage = document.querySelector( '.js-saved-carts-my-account-page-copied-message' );

		shareCartLinks.forEach( link => {
			link.addEventListener( 'click', function( e ) {
				e.preventDefault();

				const shareUrl = this.dataset.shareUrl;
				if ( shareUrl ) {
					window.navigator.clipboard.writeText( shareUrl );

					shareCartMessage.classList.add( 'is-visible' );
					shareCartMessage.setAttribute( 'aria-hidden', 'false' );
					shareCartMessage.setAttribute( 'aria-live', 'polite' );

					setTimeout( () => {
						shareCartMessage.classList.remove( 'is-visible' );
						shareCartMessage.setAttribute( 'aria-hidden', 'true' );
						shareCartMessage.removeAttribute( 'aria-live' );
					}, 5000 );
				}
			} );
		} );
	}
}
